import { useNavigate } from 'react-router-dom';
import useQuizStore from '../../store/quizStore';
import ScoreCelebration from '../../components/quiz/ScoreCelebration';

export default function ResultatQcm() {
    const navigate = useNavigate();
    const { quizInfo, scopeId, questions, questionIds, answers, correctAnswers, timeInSeconds, reset, startQuiz, isCustomQuiz } = useQuizStore();

    if (!quizInfo || !correctAnswers) {
        return (
            <div className="resultat-empty">
                <p>Aucun résultat à afficher.</p>
                <button className="btn btn-primary" onClick={() => navigate('/')}>Accueil</button>
            </div>
        );
    }

    let score = 0;
    const details = questions.map((q) => {
        const given = answers[q.id] || null;
        const correct = correctAnswers[q.id]?.correct;
        const isCorrect = given === correct;
        if (isCorrect) score++;
        return { question: q, given, correct, isCorrect };
    });

    const pct = Math.round((score / questions.length) * 100);
    const formatTime = (s) => `${Math.floor(s / 60)}:${(s % 60).toString().padStart(2, '0')}`;

    const handleRefaire = async () => {
        // Refaire le meme quiz avec les memes questions
        await startQuiz(quizInfo.id, scopeId, null, 'quiz', questionIds, 'subject', { isCustom: isCustomQuiz });
    };

    return (
        <div className="resultat-page no-select">
            <h1>R&eacute;sultat &mdash; {quizInfo.label}</h1>

            <div className="resultat-summary">
                <ScoreCelebration pct={pct} correct={score} total={questions.length} />
                <p style={{ marginTop: 10 }}>Temps : {formatTime(timeInSeconds)}</p>
            </div>

            <div className="resultat-details">
                {details.map(({ question, given, correct, isCorrect }, i) => (
                    <div key={question.id} className={`resultat-item ${isCorrect ? 'correct' : 'incorrect'}`}>
                        <div className="resultat-item-header">
                            <span className="q-num">Q{i + 1}</span>
                            <span className={`q-status ${isCorrect ? 'correct' : 'incorrect'}`}>
                                {isCorrect ? 'Correct' : 'Incorrect'}
                            </span>
                        </div>
                        {!isCorrect && (
                            <p className="resultat-correction">
                                Votre réponse : <strong>{given === '?' ? 'Je ne sais pas' : (given?.toUpperCase() || '—')}</strong>
                                {' | '}
                                Bonne réponse : <strong>{correct?.toUpperCase()}</strong>
                            </p>
                        )}
                    </div>
                ))}
            </div>

            <div className="resultat-actions">
                <button className="btn btn-primary" onClick={() => {
                    useQuizStore.setState({ isReview: true, currentIndex: 0 });
                    navigate(-1);
                }}>
                    Revoir les réponses
                </button>
                <button className="btn btn-outline" onClick={handleRefaire}>
                    Refaire ce quiz
                </button>
                <button className="btn btn-secondary" onClick={() => { reset(); navigate('/'); }}>
                    Accueil
                </button>
            </div>
        </div>
    );
}
